// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
import React from 'react';
import SVG from '@components/userDocuments/editDocument/editJournal/toolset/hoc/SVG';

export const TaskBoardIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3039)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.959 1.6665C18.959 2.01168 18.6792 2.2915 18.334 2.2915L1.66732 2.2915C1.32214 2.2915 1.04232 2.01168 1.04232 1.6665C1.04232 1.32133 1.32214 1.0415 1.66732 1.0415L18.334 1.0415C18.6792 1.0415 18.959 1.32133 18.959 1.6665Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M6.45898 10.8332C6.45898 12.0988 5.43297 13.1248 4.16732 13.1248C2.90167 13.1248 1.87565 12.0988 1.87565 10.8332L1.87565 5.83317C1.87565 4.56752 2.90167 3.5415 4.16732 3.5415C5.43297 3.5415 6.45898 4.56752 6.45898 5.83317L6.45898 10.8332Z"
        fill="#03000A"
      />
      <path
        d="M12.291 14.1665C12.291 15.4322 11.265 16.4582 9.99935 16.4582C8.7337 16.4582 7.70768 15.4322 7.70768 14.1665L7.70768 5.83317C7.70768 4.56752 8.7337 3.5415 9.99935 3.5415C11.265 3.5415 12.291 4.56752 12.291 5.83317L12.291 14.1665Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M18.125 16.6665C18.125 17.9322 17.099 18.9582 15.8333 18.9582C14.5677 18.9582 13.5417 17.9322 13.5417 16.6665L13.5417 5.83317C13.5417 4.56752 14.5677 3.5415 15.8333 3.5415C17.099 3.5415 18.125 4.56752 18.125 5.83317L18.125 16.6665Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3039">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="matrix(0 1 -1 0 20 0)"
        />
      </clipPath>
    </defs>
  </SVG>
);

export const ListingIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3040)">
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66602 1.04175C2.01119 1.04175 2.29102 1.32157 2.29102 1.66675V18.3334C2.29102 18.6786 2.01119 18.9584 1.66602 18.9584C1.32084 18.9584 1.04102 18.6786 1.04102 18.3334V1.66675C1.04102 1.32157 1.32084 1.04175 1.66602 1.04175Z"
        fill="#03000A"
      />
      <path
        d="M4.375 14.1666C4.375 12.3256 5.86738 10.8333 7.70833 10.8333H12.2917C14.1326 10.8333 15.625 12.3256 15.625 14.1666C15.625 16.0075 14.1326 17.4999 12.2917 17.4999H7.70833C5.86738 17.4999 4.375 16.0075 4.375 14.1666Z"
        fill="#03000A"
      />
      <path
        d="M4.375 5.83333C4.375 3.99238 5.86738 2.5 7.70833 2.5H15.625C17.466 2.5 18.9583 3.99238 18.9583 5.83333C18.9583 7.67428 17.466 9.16667 15.625 9.16667H7.70833C5.86738 9.16667 4.375 7.67428 4.375 5.83333Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3040">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ActivityIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3036)">
      <path
        opacity="0.4"
        d="M4.85729 2.55922L6.53533 1.79416C7.62285 1.29833 8.80413 1.04175 9.99935 1.04175C11.1946 1.04175 12.3759 1.29833 13.4634 1.79416L15.1414 2.55922C16.7046 3.27191 17.7077 4.83169 17.7077 6.54966V10.7047C17.7077 13.064 16.533 15.2685 14.5747 16.5843L11.9057 18.3775C11.342 18.7562 10.6784 18.9584 9.99935 18.9584C9.32032 18.9584 8.65668 18.7562 8.09305 18.3775L5.42405 16.5843C3.4657 15.2685 2.29102 13.064 2.29102 10.7047V6.54966C2.29102 4.83168 3.29412 3.27191 4.85729 2.55922Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2864 7.82889C13.565 8.03272 13.6256 8.42378 13.4217 8.70235L11.9576 10.7035L11.9515 10.7112C11.171 11.7103 10.2704 12.3327 9.24525 12.2896C8.23987 12.2473 7.35943 11.5715 6.5915 10.5886C6.37899 10.3166 6.42723 9.92379 6.69923 9.71129C6.97124 9.49878 7.36402 9.54701 7.57653 9.81902C8.26693 10.7027 8.84483 11.0216 9.29777 11.0407C9.72966 11.0588 10.2854 10.8107 10.9606 9.94925L12.4129 7.96424C12.6168 7.68566 13.0078 7.62507 13.2864 7.82889Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3036">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const EditListingIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3037)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79101 1.66606C9.7918 2.01124 9.51261 2.29169 9.16744 2.29248C6.95176 2.29752 5.91587 2.35409 5.11612 2.71403C4.04846 3.19454 3.19368 4.04933 2.71316 5.11699C2.51706 5.55271 2.40611 6.07585 2.34899 6.85388C2.29141 7.63813 2.29102 8.63118 2.29102 10.0002C2.29102 11.3692 2.29141 12.3623 2.34899 13.1466C2.40611 13.9246 2.51706 14.4477 2.71316 14.8834C3.19368 15.9511 4.04846 16.8059 5.11612 17.2864C5.55185 17.4825 6.07499 17.5935 6.85301 17.6506C7.63726 17.7082 8.63032 17.7085 9.99935 17.7085C11.3684 17.7085 12.3614 17.7082 13.1457 17.6506C13.9237 17.5935 14.4469 17.4825 14.8826 17.2864C15.9502 16.8059 16.805 15.9511 17.2855 14.8834C17.4816 14.4477 17.5926 13.9246 17.6497 13.1466C17.7073 12.3623 17.7077 11.3692 17.7077 10.0002C17.7077 9.65504 17.9875 9.37522 18.3327 9.37522C18.6779 9.37522 18.9577 9.65504 18.9577 10.0002V10.0257C18.9577 11.364 18.9577 12.4027 18.8964 13.2381C18.8342 14.0849 18.7065 14.7719 18.4254 15.3965C17.8195 16.7426 16.7418 17.8204 15.3956 18.4263C14.771 18.7074 14.0841 18.835 13.2372 18.8972C12.4019 18.9586 11.3631 18.9586 10.0248 18.9585H9.9739C8.63561 18.9586 7.59683 18.9586 6.76148 18.8972C5.91462 18.835 5.22769 18.7074 4.60311 18.4263C3.25693 17.8204 2.17915 16.7426 1.57329 15.3965C1.29218 14.7719 1.16452 14.0849 1.10234 13.2381C1.04101 12.4027 1.04101 11.3639 1.04102 10.0256V9.9748C1.04101 8.63649 1.04101 7.5977 1.10234 6.76235C1.16452 5.91548 1.29218 5.22856 1.57329 4.60397C2.17915 3.25779 3.25693 2.18002 4.60311 1.57415C5.69541 1.08255 7.02841 1.04734 9.16459 1.04248C9.50977 1.0417 9.79023 1.32088 9.79101 1.66606Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10.6405 4.0249L7.62783 7.0376C7.18978 7.47566 6.97075 7.69468 6.78386 7.92813C6.14227 8.72954 5.74163 9.69677 5.62862 10.7171C5.5957 11.0143 5.5957 11.3241 5.5957 11.9436C5.59571 12.3786 5.5957 12.5963 5.63609 12.7764C5.77719 13.4056 6.26852 13.8969 6.89767 14.038C7.07777 14.0784 7.29533 14.0784 7.73043 14.0784C8.34991 14.0784 8.65976 14.0784 8.95698 14.0455C9.97734 13.9325 10.9446 13.5318 11.746 12.8902C11.9794 12.7034 12.1985 12.4843 12.6365 12.0463L15.6492 9.03357L10.6405 4.0249Z"
        fill="#03000A"
      />
      <path
        d="M11.5254 3.1417L12.0785 2.5886C13.4616 1.20549 15.7041 1.20549 17.0872 2.5886C18.4703 3.97171 18.4703 6.21417 17.0872 7.59727L16.5341 8.15037L11.5254 3.1417Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3037">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const ManageAccountIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3038)">
      <path
        opacity="0.4"
        d="M1.04102 10C1.04102 7.67211 1.04102 6.50816 1.38024 5.57614C1.94892 4.0137 3.17972 2.78291 4.74215 2.21423C5.67418 1.875 6.83812 1.875 9.16602 1.875H10.8327C13.1606 1.875 14.3245 1.875 15.2565 2.21423C16.819 2.78291 18.0498 4.0137 18.6185 5.57614C18.9577 6.50816 18.9577 7.67211 18.9577 10C18.9577 12.3279 18.9577 13.4918 18.6185 14.4239C18.0498 15.9863 16.819 17.2171 15.2565 17.7858C14.3245 18.125 13.1606 18.125 10.8327 18.125H9.16602C6.83812 18.125 5.67418 18.125 4.74215 17.7858C3.17972 17.2171 1.94892 15.9863 1.38024 14.4239C1.04102 13.4918 1.04102 12.3279 1.04102 10Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.709 7.5C12.709 7.15482 12.9888 6.875 13.334 6.875H15.0007C15.3458 6.875 15.6257 7.15482 15.6257 7.5C15.6257 7.84518 15.3458 8.125 15.0007 8.125H13.334C12.9888 8.125 12.709 7.84518 12.709 7.5Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.709 10C12.709 9.65482 12.9888 9.375 13.334 9.375H15.0007C15.3458 9.375 15.6257 9.65482 15.6257 10C15.6257 10.3452 15.3458 10.625 15.0007 10.625H13.334C12.9888 10.625 12.709 10.3452 12.709 10Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.709 12.5C12.709 12.1548 12.9888 11.875 13.334 11.875H15.0007C15.3458 11.875 15.6257 12.1548 15.6257 12.5C15.6257 12.8452 15.3458 13.125 15.0007 13.125H13.334C12.9888 13.125 12.709 12.8452 12.709 12.5Z"
        fill="#03000A"
      />
      <path
        d="M5 8.75C5 10.1307 6.11929 11.25 7.5 11.25C8.88071 11.25 10 10.1307 10 8.75C10 7.36929 8.88071 6.25 7.5 6.25C6.11929 6.25 5 7.36929 5 8.75Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 11.4585C6.46447 11.4585 5.625 12.298 5.625 13.3335C5.625 13.6787 5.34518 13.9585 5 13.9585C4.65482 13.9585 4.375 13.6787 4.375 13.3335C4.375 11.6076 5.77411 10.2085 7.5 10.2085C9.22589 10.2085 10.625 11.6076 10.625 13.3335C10.625 13.6787 10.3452 13.9585 10 13.9585C9.65482 13.9585 9.375 13.6787 9.375 13.3335C9.375 12.298 8.53553 11.4585 7.5 11.4585Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3038">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const AnalyticsIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3146)">
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 1.0415C2.84518 1.0415 3.125 1.32133 3.125 1.6665V13.3332C3.125 15.7493 5.08415 17.7082 7.50048 17.7082H17.5C17.8452 17.7082 18.125 17.988 18.125 18.3332C18.125 18.6783 17.8452 18.9582 17.5 18.9582H7.50048C4.39395 18.9582 1.875 16.4398 1.875 13.3332V1.6665C1.875 1.32133 2.15482 1.0415 2.5 1.0415Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10 4.99984C10 6.84079 11.4924 8.33317 13.3333 8.33317C15.1743 8.33317 16.6667 6.84079 16.6667 4.99984C16.6667 3.15889 15.1743 1.6665 13.3333 1.6665C11.4924 1.6665 10 3.15889 10 4.99984Z"
        fill="#03000A"
      />
      <path
        d="M12.5 12.9168C12.5 14.0674 13.4327 15.0002 14.5833 15.0002C15.7339 15.0002 16.6667 14.0674 16.6667 12.9168C16.6667 11.7662 15.7339 10.8335 14.5833 10.8335C13.4327 10.8335 12.5 11.7662 12.5 12.9168Z"
        fill="#03000A"
      />
      <path
        d="M5 10.8335C5 12.2142 6.11929 13.3335 7.5 13.3335C8.88071 13.3335 10 12.2142 10 10.8335C10 9.45278 8.88071 8.3335 7.5 8.3335C6.11929 8.3335 5 9.45278 5 10.8335Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3146">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const UsersIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_13346_926)">
      <path
        d="M3 7.5C3 10.9518 5.79822 13.75 9.25 13.75C12.7018 13.75 15.5 10.9518 15.5 7.5C15.5 4.04822 12.7018 1.25 9.25 1.25C5.79822 1.25 3 4.04822 3 7.5Z"
        fill="#03000A"
      />
      <path
        d="M13.7598 13.6729C15.7168 12.3195 16.9989 10.0595 16.9989 7.5C16.9989 4.94051 15.7168 2.68048 13.7598 1.32708C14.0804 1.27635 14.4092 1.25 14.7442 1.25C18.1959 1.25 20.9942 4.04822 20.9942 7.5C20.9942 10.9518 18.1959 13.75 14.7442 13.75C14.4092 13.75 14.0804 13.7237 13.7598 13.6729Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M1.65732 21.151L1.25 22.75H17.25L16.8425 21.1506C15.9581 17.6794 12.8321 15.25 9.24996 15.25C5.66768 15.25 2.54161 17.6796 1.65732 21.151Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M18.7347 22.75L18.3539 20.9564C17.7859 18.2813 15.8361 16.1932 13.3477 15.3751C13.8027 15.2928 14.2699 15.25 14.7452 15.25C18.3273 15.25 21.4533 17.6794 22.3377 21.1506L22.7453 22.75H18.7347Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_13346_926">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const UserSubmitIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12917_5720)">
      <path
        d="M3.54102 6.25033C3.54102 9.12681 5.87287 11.4587 8.74935 11.4587C11.6258 11.4587 13.9577 9.12681 13.9577 6.25033C13.9577 3.37384 11.6258 1.04199 8.74935 1.04199C5.87287 1.04199 3.54102 3.37384 3.54102 6.25033Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10.6952 18.9581C9.51233 18.0436 8.75065 16.6108 8.75065 15C8.75065 14.1895 8.94349 13.4241 9.28578 12.7471C6.60691 13.0407 4.35083 14.9663 3.67342 17.6256L3.33398 18.9581H10.6952Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7493 18.9587C11.5632 18.9587 9.79102 17.1865 9.79102 15.0003C9.79102 12.8142 11.5632 11.042 13.7493 11.042C15.9355 11.042 17.7077 12.8142 17.7077 15.0003C17.7077 17.1865 15.9355 18.9587 13.7493 18.9587ZM15.4413 15.0256C15.6854 14.7815 15.6854 14.3858 15.4413 14.1417C15.1972 13.8976 14.8015 13.8976 14.5574 14.1417L13.8356 14.8635C13.6729 15.0262 13.4091 15.0262 13.2464 14.8635L12.9413 14.5584C12.6972 14.3143 12.3015 14.3143 12.0574 14.5584C11.8133 14.8025 11.8133 15.1982 12.0574 15.4423L12.3625 15.7474C13.0134 16.3982 14.0687 16.3982 14.7195 15.7474L15.4413 15.0256Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12917_5720">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const UserAssignedIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12917_4899)">
      <path
        d="M3.54102 6.25033C3.54102 9.12681 5.87287 11.4587 8.74935 11.4587C11.6258 11.4587 13.9577 9.12681 13.9577 6.25033C13.9577 3.37384 11.6258 1.04199 8.74935 1.04199C5.87287 1.04199 3.54102 3.37384 3.54102 6.25033Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10.6952 18.9581C9.51233 18.0436 8.75065 16.6108 8.75065 15C8.75065 14.1895 8.94349 13.4241 9.28578 12.7471C6.60691 13.0407 4.35083 14.9663 3.67342 17.6256L3.33398 18.9581H10.6952Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79102 15.0003C9.79102 17.1865 11.5632 18.9587 13.7493 18.9587C15.9355 18.9587 17.7077 17.1865 17.7077 15.0003C17.7077 12.8142 15.9355 11.042 13.7493 11.042C11.5632 11.042 9.79102 12.8142 9.79102 15.0003ZM13.7493 16.4587C14.0945 16.4587 14.3743 16.1788 14.3743 15.8337V15.6253H14.5827C14.9279 15.6253 15.2077 15.3455 15.2077 15.0003C15.2077 14.6551 14.9279 14.3753 14.5827 14.3753H14.3743V14.167C14.3743 13.8218 14.0945 13.542 13.7493 13.542C13.4042 13.542 13.1243 13.8218 13.1243 14.167V14.3753H12.916C12.5708 14.3753 12.291 14.6551 12.291 15.0003C12.291 15.3455 12.5708 15.6253 12.916 15.6253H13.1243V15.8337C13.1243 16.1788 13.4042 16.4587 13.7493 16.4587Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12917_4899">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const UserUnAssignedIcon = ({ height = '20', width = '20' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_12917_4898)">
      <path
        d="M3.54102 6.25033C3.54102 9.12681 5.87287 11.4587 8.74935 11.4587C11.6258 11.4587 13.9577 9.12681 13.9577 6.25033C13.9577 3.37384 11.6258 1.04199 8.74935 1.04199C5.87287 1.04199 3.54102 3.37384 3.54102 6.25033Z"
        fill="#03000A"
      />
      <path
        opacity="0.4"
        d="M10.6952 18.9581C9.51233 18.0436 8.75065 16.6108 8.75065 15C8.75065 14.1895 8.94349 13.4241 9.28578 12.7471C6.60691 13.0407 4.35083 14.9663 3.67342 17.6256L3.33398 18.9581H10.6952Z"
        fill="#03000A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79102 15.0003C9.79102 17.1865 11.5632 18.9587 13.7493 18.9587C15.9355 18.9587 17.7077 17.1865 17.7077 15.0003C17.7077 12.8142 15.9355 11.042 13.7493 11.042C11.5632 11.042 9.79102 12.8142 9.79102 15.0003ZM15.0246 13.7251C15.2687 13.9691 15.2687 14.3649 15.0246 14.6089L14.6332 15.0003L15.0246 15.3917C15.2687 15.6358 15.2687 16.0315 15.0246 16.2756C14.7805 16.5197 14.3848 16.5197 14.1407 16.2756L13.7493 15.8842L13.358 16.2756C13.1139 16.5197 12.7182 16.5197 12.4741 16.2756C12.23 16.0315 12.23 15.6358 12.4741 15.3917L12.8655 15.0003L12.4741 14.6089C12.23 14.3649 12.23 13.9691 12.4741 13.7251C12.7182 13.481 13.1139 13.481 13.358 13.7251L13.7493 14.1164L14.1407 13.7251C14.3848 13.481 14.7805 13.481 15.0246 13.7251Z"
        fill="#03000A"
      />
    </g>
    <defs>
      <clipPath id="clip0_12917_4898">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const RejectedIcon = ({ height = '16', width = '16' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewbox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_12796_2715)">
      <path
        d="M5.33268 2.78564C5.12395 2.82712 4.93901 2.88301 4.76639 2.95832C3.95709 3.31142 3.31114 3.95736 2.95805 4.76667C2.66602 5.43601 2.66602 6.29055 2.66602 7.99962V9.33296C2.66602 11.042 2.66602 11.8966 2.95805 12.5659C3.31114 13.3752 3.95709 14.0212 4.76639 14.3743C5.43574 14.6663 6.29027 14.6663 7.99935 14.6663C9.70842 14.6663 10.563 14.6663 11.2323 14.3743C12.0416 14.0212 12.6876 13.3752 13.0406 12.5659C13.3327 11.8966 13.3327 11.042 13.3327 9.33296V7.99963C13.3327 6.29055 13.3327 5.43601 13.0406 4.76667C12.6876 3.95736 12.0416 3.31142 11.2323 2.95832C11.0597 2.88301 10.8747 2.82712 10.666 2.78564"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.33268 8L6.66602 10.6667"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 8L9.33268 10.6667"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 2.66683C5.33398 1.93045 5.93094 1.3335 6.66732 1.3335H9.33398C10.0704 1.3335 10.6673 1.93045 10.6673 2.66683C10.6673 3.40321 10.0704 4.00016 9.33398 4.00016H6.66732C5.93094 4.00016 5.33398 3.40321 5.33398 2.66683Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12796_2715">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);
export const CancelledIcon = ({ height = '16', width = '16' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewbox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_12796_2699)">
      <path
        d="M5.33268 2.78564C5.12395 2.82712 4.93901 2.88301 4.76639 2.95832C3.95709 3.31142 3.31114 3.95736 2.95805 4.76667C2.66602 5.43601 2.66602 6.29055 2.66602 7.99962V9.33296C2.66602 11.042 2.66602 11.8966 2.95805 12.5659C3.31114 13.3752 3.95709 14.0212 4.76639 14.3743C5.43574 14.6663 6.29027 14.6663 7.99935 14.6663C9.70842 14.6663 10.563 14.6663 11.2323 14.3743C12.0416 14.0212 12.6876 13.3752 13.0406 12.5659C13.3327 11.8966 13.3327 11.042 13.3327 9.33296V7.99963C13.3327 6.29055 13.3327 5.43601 13.0406 4.76667C12.6876 3.95736 12.0416 3.31142 11.2323 2.95832C11.0597 2.88301 10.8747 2.82712 10.666 2.78564"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.33268 8L6.66602 10.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 8L9.33268 10.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33398 2.66683C5.33398 1.93045 5.93094 1.3335 6.66732 1.3335H9.33398C10.0704 1.3335 10.6673 1.93045 10.6673 2.66683C10.6673 3.40321 10.0704 4.00016 9.33398 4.00016H6.66732C5.93094 4.00016 5.33398 3.40321 5.33398 2.66683Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12796_2699">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);
export const DoneIcon = ({ height = '16', width = '16' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewbox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_12796_2698)">
      <path
        d="M5.33268 2.78564C5.12395 2.82712 4.93901 2.88301 4.76639 2.95832C3.95709 3.31142 3.31114 3.95736 2.95805 4.76667C2.66602 5.43601 2.66602 6.29055 2.66602 7.99962V9.33296C2.66602 11.042 2.66602 11.8966 2.95805 12.5659C3.31114 13.3752 3.95709 14.0212 4.76639 14.3743C5.43574 14.6663 6.29027 14.6663 7.99935 14.6663C9.70842 14.6663 10.563 14.6663 11.2323 14.3743C12.0416 14.0212 12.6876 13.3752 13.0406 12.5659C13.3327 11.8966 13.3327 11.042 13.3327 9.33296V7.99963C13.3327 6.29055 13.3327 5.43601 13.0406 4.76667C12.6876 3.95736 12.0416 3.31142 11.2323 2.95832C11.0597 2.88301 10.8747 2.82712 10.666 2.78564"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6 9.33333L6.57474 10.1954C6.95016 10.7586 7.76486 10.7939 8.18765 10.2654L10 8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.33398 2.66683C5.33398 1.93045 5.93094 1.3335 6.66732 1.3335H9.33398C10.0704 1.3335 10.6673 1.93045 10.6673 2.66683C10.6673 3.40321 10.0704 4.00016 9.33398 4.00016H6.66732C5.93094 4.00016 5.33398 3.40321 5.33398 2.66683Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_12796_2698">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const BoltIcon = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.82454 19.8745L16.7995 11.4995H12.2995L13.1995 4.34952L6.87454 13.4995H10.7245L9.82454 19.8745ZM8.99954 14.9995H5.42454C5.12668 14.9995 4.90638 14.8662 4.76364 14.5995C4.62091 14.3329 4.64121 14.0745 4.82454 13.8245L13.2745 1.62452C13.4079 1.44119 13.5745 1.31619 13.7745 1.24952C13.9745 1.18286 14.1745 1.19119 14.3745 1.27452C14.5745 1.35786 14.7329 1.49261 14.8495 1.67877C14.9662 1.86494 15.0079 2.06352 14.9745 2.27452L13.9995 9.99952H18.3995C18.7222 9.99952 18.9488 10.1412 19.0791 10.4245C19.2094 10.7079 19.1745 10.9745 18.9745 11.2245L9.69954 22.3495C9.55884 22.5146 9.38617 22.6225 9.18152 22.6733C8.97687 22.7241 8.78288 22.7058 8.59954 22.6183C8.41621 22.5308 8.27038 22.3964 8.16204 22.2151C8.05371 22.0339 8.01621 21.837 8.04954 21.6245L8.99954 14.9995Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const ScheduleIcon = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.825 11.7V7.425C12.825 7.20833 12.7542 7.02917 12.6125 6.8875C12.4708 6.74583 12.2917 6.675 12.075 6.675C11.8583 6.675 11.6792 6.74583 11.5375 6.8875C11.3958 7.02917 11.325 7.20833 11.325 7.425V12C11.325 12.1 11.3417 12.1917 11.375 12.275C11.4083 12.3583 11.4583 12.4417 11.525 12.525L15.125 16.25C15.275 16.4167 15.4625 16.4958 15.6875 16.4875C15.9125 16.4792 16.1 16.4 16.25 16.25C16.4 16.1 16.475 15.9167 16.475 15.7C16.475 15.4833 16.4 15.3 16.25 15.15L12.825 11.7ZM12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6333 2.2625 9.34167 2.7875 8.125C3.3125 6.90833 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3667 2 14.6583 2.2625 15.875 2.7875C17.0917 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90833 21.2125 8.125C21.7375 9.34167 22 10.6333 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0917 20.6875 15.875 21.2125C14.6583 21.7375 13.3667 22 12 22ZM12 20.5C14.3333 20.5 16.3333 19.6667 18 18C19.6667 16.3333 20.5 14.3333 20.5 12C20.5 9.66667 19.6667 7.66667 18 6C16.3333 4.33333 14.3333 3.5 12 3.5C9.66667 3.5 7.66667 4.33333 6 6C4.33333 7.66667 3.5 9.66667 3.5 12C3.5 14.3333 4.33333 16.3333 6 18C7.66667 19.6667 9.66667 20.5 12 20.5Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const TimerIcon = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.75 2.5C9.5375 2.5 9.35938 2.42771 9.21563 2.28313C9.07188 2.13853 9 1.95936 9 1.74563C9 1.53188 9.07188 1.35417 9.21563 1.2125C9.35938 1.07083 9.5375 1 9.75 1H14.25C14.4625 1 14.6406 1.07229 14.7844 1.21687C14.9281 1.36147 15 1.54064 15 1.75437C15 1.96812 14.9281 2.14583 14.7844 2.2875C14.6406 2.42917 14.4625 2.5 14.25 2.5H9.75ZM12.0044 13.675C12.2181 13.675 12.3958 13.6031 12.5375 13.4594C12.6792 13.3156 12.75 13.1375 12.75 12.925V8.675C12.75 8.4625 12.6777 8.28438 12.5331 8.14062C12.3885 7.99688 12.2094 7.925 11.9956 7.925C11.7819 7.925 11.6042 7.99688 11.4625 8.14062C11.3208 8.28438 11.25 8.4625 11.25 8.675V12.925C11.25 13.1375 11.3223 13.3156 11.4669 13.4594C11.6115 13.6031 11.7906 13.675 12.0044 13.675ZM12 21.975C10.7667 21.975 9.60417 21.7375 8.5125 21.2625C7.42083 20.7875 6.46667 20.1417 5.65 19.325C4.83333 18.5083 4.1875 17.5542 3.7125 16.4625C3.2375 15.3708 3 14.2083 3 12.975C3 11.7417 3.2375 10.5792 3.7125 9.4875C4.1875 8.39583 4.83333 7.44167 5.65 6.625C6.46667 5.80833 7.42083 5.1625 8.5125 4.6875C9.60417 4.2125 10.7667 3.975 12 3.975C13.1167 3.975 14.1667 4.1625 15.15 4.5375C16.1333 4.9125 17.0083 5.43333 17.775 6.1L18.525 5.35C18.675 5.2 18.85 5.125 19.05 5.125C19.25 5.125 19.425 5.2 19.575 5.35C19.725 5.5 19.8 5.675 19.8 5.875C19.8 6.075 19.725 6.25 19.575 6.4L18.825 7.15C19.425 7.81667 19.9375 8.625 20.3625 9.575C20.7875 10.525 21 11.6583 21 12.975C21 14.2083 20.7625 15.3708 20.2875 16.4625C19.8125 17.5542 19.1667 18.5083 18.35 19.325C17.5333 20.1417 16.5792 20.7875 15.4875 21.2625C14.3958 21.7375 13.2333 21.975 12 21.975ZM12 20.475C14.0833 20.475 15.8542 19.7458 17.3125 18.2875C18.7708 16.8292 19.5 15.0583 19.5 12.975C19.5 10.8917 18.7708 9.12083 17.3125 7.6625C15.8542 6.20417 14.0833 5.475 12 5.475C9.91667 5.475 8.14583 6.20417 6.6875 7.6625C5.22917 9.12083 4.5 10.8917 4.5 12.975C4.5 15.0583 5.22917 16.8292 6.6875 18.2875C8.14583 19.7458 9.91667 20.475 12 20.475Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const TrackRecordIcon = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.375 21.025C6.775 21.0083 6.20417 20.8542 5.6625 20.5625C5.12083 20.2708 4.60833 19.8417 4.125 19.275C3.45833 18.475 2.9375 17.5208 2.5625 16.4125C2.1875 15.3042 2 14.1667 2 13C2 11.6167 2.2625 10.3167 2.7875 9.1C3.3125 7.88333 4.025 6.825 4.925 5.925C5.825 5.025 6.88333 4.3125 8.1 3.7875C9.31667 3.2625 10.6167 3 12 3C13.3833 3 14.6833 3.2625 15.9 3.7875C17.1167 4.3125 18.175 5.03333 19.075 5.95C19.975 6.86667 20.6875 7.94167 21.2125 9.175C21.7375 10.4083 22 11.7333 22 13.15C22 14.4 21.8 15.5833 21.4 16.7C21 17.8167 20.425 18.7583 19.675 19.525C19.1917 20.025 18.6875 20.4 18.1625 20.65C17.6375 20.9 17.1 21.025 16.55 21.025C16.25 21.025 15.95 20.9875 15.65 20.9125C15.35 20.8375 15.05 20.725 14.75 20.575L13.35 19.875C13.1333 19.7583 12.9125 19.675 12.6875 19.625C12.4625 19.575 12.2333 19.55 12 19.55C11.7667 19.55 11.5375 19.575 11.3125 19.625C11.0875 19.675 10.8667 19.7583 10.65 19.875L9.25 20.575C8.93333 20.7417 8.62083 20.8625 8.3125 20.9375C8.00417 21.0125 7.69167 21.0417 7.375 21.025ZM7.45 19.525C7.63333 19.525 7.82083 19.5 8.0125 19.45C8.20417 19.4 8.39167 19.3333 8.575 19.25L9.975 18.55C10.2917 18.4 10.6167 18.2833 10.95 18.2C11.2833 18.1167 11.625 18.075 11.975 18.075C12.325 18.075 12.6667 18.1125 13 18.1875C13.3333 18.2625 13.6667 18.3833 14 18.55L15.425 19.25C15.6083 19.3333 15.7917 19.4 15.975 19.45C16.1583 19.5 16.3417 19.525 16.525 19.525C16.9083 19.525 17.2792 19.4333 17.6375 19.25C17.9958 19.0667 18.3417 18.7917 18.675 18.425C19.2583 17.7917 19.7083 17.0125 20.025 16.0875C20.3417 15.1625 20.5 14.1833 20.5 13.15C20.5 10.7167 19.6792 8.66667 18.0375 7C16.3958 5.33333 14.3833 4.5 12 4.5C9.61667 4.5 7.60417 5.34167 5.9625 7.025C4.32083 8.70833 3.5 10.7667 3.5 13.2C3.5 14.25 3.65833 15.2292 3.975 16.1375C4.29167 17.0458 4.74167 17.8167 5.325 18.45C5.65833 18.8167 6 19.0875 6.35 19.2625C6.7 19.4375 7.06667 19.525 7.45 19.525ZM12 14.75C12.4833 14.75 12.8958 14.5792 13.2375 14.2375C13.5792 13.8958 13.75 13.4833 13.75 13C13.75 12.8667 13.7375 12.7333 13.7125 12.6C13.6875 12.4667 13.6417 12.3417 13.575 12.225L15.175 10.175C15.375 10.4083 15.55 10.6542 15.7 10.9125C15.85 11.1708 15.9667 11.45 16.05 11.75C16.1 11.9333 16.1958 12.0958 16.3375 12.2375C16.4792 12.3792 16.6417 12.45 16.825 12.45C17.0917 12.45 17.2917 12.3375 17.425 12.1125C17.5583 11.8875 17.5833 11.6417 17.5 11.375C17.1167 10.1583 16.4208 9.16667 15.4125 8.4C14.4042 7.63333 13.2667 7.25 12 7.25C10.7167 7.25 9.57083 7.62917 8.5625 8.3875C7.55417 9.14583 6.86667 10.1417 6.5 11.375C6.41667 11.6417 6.44583 11.8875 6.5875 12.1125C6.72917 12.3375 6.925 12.45 7.175 12.45C7.35833 12.45 7.51667 12.3792 7.65 12.2375C7.78333 12.0958 7.88333 11.9333 7.95 11.75C8.23333 10.85 8.74583 10.125 9.4875 9.575C10.2292 9.025 11.0667 8.75 12 8.75C12.35 8.75 12.6917 8.79167 13.025 8.875C13.3583 8.95833 13.6833 9.08333 14 9.25L12.4 11.3C12.3333 11.2833 12.2667 11.2708 12.2 11.2625C12.1333 11.2542 12.0667 11.25 12 11.25C11.5167 11.25 11.1042 11.4208 10.7625 11.7625C10.4208 12.1042 10.25 12.5167 10.25 13C10.25 13.4833 10.4208 13.8958 10.7625 14.2375C11.1042 14.5792 11.5167 14.75 12 14.75Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const WiseFileUploadIcon = ({ width = '32', height = '32' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 32 32"
    fill="none"
  >
    <g clipPath="url(#clip0_12860_3265)">
      <path
        d="M16.5354 17.7742H19.7479C20.0263 17.7676 20.2954 17.673 20.5166 17.5038C20.7378 17.3347 20.8996 17.0997 20.9789 16.8328L24.9748 1.97497C25.034 1.78349 25.0471 1.58072 25.0129 1.38322C24.9788 1.18573 24.8984 0.999107 24.7784 0.838613C24.6583 0.678118 24.502 0.548302 24.3222 0.459771C24.1424 0.371239 23.9442 0.326503 23.7438 0.329218H20.5642C20.2858 0.335792 20.0167 0.430455 19.7955 0.5996C19.5743 0.768745 19.4124 1.00366 19.3332 1.27059L15.3044 16.135C15.2479 16.326 15.2369 16.5276 15.2722 16.7237C15.3075 16.9197 15.3882 17.1047 15.5079 17.264C15.6275 17.4233 15.7827 17.5524 15.9611 17.641C16.1395 17.7296 16.3362 17.7752 16.5354 17.7742Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M6.01631 16.8064L10.0517 1.97488C10.1094 1.78345 10.1214 1.58114 10.0866 1.38425C10.0519 1.18735 9.97138 1.00136 9.85162 0.841253C9.73186 0.681146 9.57618 0.551395 9.39712 0.462445C9.21805 0.373495 9.0206 0.32783 8.82067 0.329128H5.64108C5.36106 0.329383 5.08889 0.42166 4.86646 0.591754C4.64403 0.761849 4.48366 1.00033 4.41005 1.2705L0.374669 16.1349C0.318194 16.3259 0.307185 16.5275 0.342522 16.7236C0.377858 16.9196 0.45856 17.1046 0.578179 17.2639C0.697797 17.4232 0.853015 17.5523 1.03143 17.6409C1.20984 17.7295 1.4065 17.7751 1.60569 17.7741H4.78528C5.06878 17.7723 5.34362 17.6762 5.5665 17.501C5.78938 17.3258 5.94763 17.0815 6.01631 16.8064Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M11.3426 9.37418H14.5222C14.8022 9.37393 15.0744 9.28165 15.2968 9.11156C15.5192 8.94146 15.6796 8.70298 15.7532 8.43281L17.5175 1.97488C17.5752 1.78345 17.5871 1.58114 17.5524 1.38425C17.5176 1.18735 17.4371 1.00136 17.3174 0.841253C17.1976 0.681146 17.0419 0.551395 16.8629 0.462445C16.6838 0.373495 16.4864 0.32783 16.2864 0.329128H13.1003C12.8185 0.331534 12.5449 0.424281 12.3198 0.593731C12.0946 0.763182 11.9298 1.0004 11.8495 1.2705L10.1116 7.76793C10.0598 7.95693 10.0524 8.15534 10.0901 8.34766C10.1277 8.53998 10.2093 8.72098 10.3285 8.87652C10.4477 9.03206 10.6013 9.15792 10.7772 9.24425C10.9531 9.33059 11.1466 9.37505 11.3426 9.37418Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3895 10.6187H10.2099C9.92993 10.6189 9.65776 10.7112 9.43533 10.8813C9.2129 11.0514 9.05253 11.2899 8.97892 11.56L4.94354 26.4245C4.89314 26.6134 4.8868 26.8114 4.925 27.0031C4.96319 27.1949 5.04491 27.3753 5.16384 27.5305C5.28278 27.6857 5.43576 27.8115 5.61099 27.8982C5.78623 27.9849 5.97904 28.0303 6.17456 28.0307H9.36073C9.64075 28.0305 9.91292 27.9382 10.1353 27.7681C10.3578 27.598 10.5181 27.3595 10.5918 27.0894L14.6206 12.2249C14.6723 12.0359 14.6797 11.8375 14.6421 11.6452C14.6044 11.4529 14.5228 11.2719 14.4036 11.1163C14.2844 10.9608 14.1309 10.8349 13.9549 10.7486C13.779 10.6623 13.5855 10.6178 13.3895 10.6187Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M28.3061 10.6183H25.1397C24.8594 10.6174 24.5867 10.7093 24.364 10.8796C24.1414 11.0498 23.9813 11.2889 23.9087 11.5597L19.8733 26.4241C19.8215 26.6131 19.8141 26.8115 19.8518 27.0038C19.8894 27.1962 19.971 27.3772 20.0902 27.5327C20.2094 27.6882 20.363 27.8141 20.5389 27.9004C20.7148 27.9868 20.9083 28.0312 21.1043 28.0304H24.2839C24.5642 28.0312 24.8369 27.9394 25.0596 27.7691C25.2822 27.5988 25.4423 27.3597 25.5149 27.089L29.5503 12.2246C29.6024 12.0345 29.6096 11.8349 29.5712 11.6416C29.5329 11.4482 29.4501 11.2665 29.3294 11.1107C29.2087 10.9548 29.0534 10.8292 28.8758 10.7438C28.6982 10.6583 28.5032 10.6154 28.3061 10.6183Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M18.5832 18.9854H15.4036C15.1253 18.9919 14.8562 19.0866 14.635 19.2558C14.4138 19.4249 14.2519 19.6598 14.1726 19.9267L12.4084 26.4242C12.358 26.6131 12.3516 26.8111 12.3898 27.0028C12.428 27.1946 12.5098 27.375 12.6287 27.5302C12.7476 27.6854 12.9006 27.8112 13.0758 27.8979C13.2511 27.9846 13.4439 28.03 13.6394 28.0304H16.819C17.0996 28.0324 17.3728 27.941 17.5957 27.7705C17.8186 27.6001 17.9784 27.3603 18.05 27.0891L19.8143 20.5982C19.8673 20.4088 19.8756 20.2096 19.8385 20.0165C19.8014 19.8233 19.72 19.6414 19.6007 19.485C19.4813 19.3287 19.3273 19.2021 19.1508 19.1154C18.9742 19.0287 18.7799 18.9842 18.5832 18.9854Z"
        stroke="#4660F9"
        strokeMiterlimit="10"
      />
      <path
        d="M21.5859 27.0955L26.7536 22.1978L31.9278 27.0955H28.6363V31.9999H24.8511V27.0955H21.5859Z"
        fill="#4660F9"
      />
    </g>
    <defs>
      <clipPath id="clip0_12860_3265">
        <rect width="31.9276" height="32" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const LocalFileUploadIcon = ({ width = '32', height = '32' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 32 32"
    fill="none"
  >
    <path
      d="M15.5275 16.8744V23.1385C15.5275 23.2846 15.5771 23.4066 15.6761 23.5045C15.7752 23.6024 15.8987 23.6513 16.0467 23.6513C16.1946 23.6513 16.316 23.6024 16.4109 23.5045C16.5057 23.4066 16.5532 23.2846 16.5532 23.1385V16.8744L19.2532 19.6C19.2857 19.6325 19.3669 19.6231 19.4968 19.5718C19.6267 19.5205 19.7485 19.4761 19.8622 19.4385C19.9758 19.4009 20.06 19.3833 20.1147 19.3859C20.1694 19.3885 20.1267 19.4598 19.9865 19.6C20.101 19.4855 20.1528 19.3632 20.1416 19.2333C20.1305 19.1034 20.0763 18.9812 19.9788 18.8667L16.6397 15.579C16.5513 15.4887 16.45 15.4214 16.3359 15.3769C16.2218 15.3325 16.1082 15.3103 15.9949 15.3103C15.8816 15.3103 15.7694 15.3325 15.6583 15.3769C15.5472 15.4214 15.4474 15.4883 15.359 15.5776L12.0532 18.9077C11.9558 19.0051 11.9028 19.1231 11.8942 19.2615C11.8857 19.4 11.9301 19.5308 12.0275 19.6541C12.1421 19.7428 12.2686 19.7872 12.407 19.7872C12.5455 19.7872 12.6635 19.7385 12.7609 19.641L15.5275 16.8744ZM8.51215 28C7.99977 28 7.56398 27.8204 7.20478 27.4612C6.8456 27.102 6.66602 26.6662 6.66602 26.1539V5.84613C6.66602 5.33375 6.8456 4.89797 7.20478 4.53877C7.56398 4.17959 7.99977 4 8.51215 4H18.8916C19.1511 4 19.3933 4.05128 19.6183 4.15383C19.8433 4.25641 20.0446 4.38803 20.2224 4.5487L24.784 9.11027C24.9446 9.28804 25.0763 9.48942 25.1788 9.7144C25.2814 9.93938 25.3327 10.1816 25.3327 10.441V26.1539C25.3327 26.6662 25.1531 27.102 24.7939 27.4612C24.4347 27.8204 23.9989 28 23.4865 28H8.51215ZM19.1352 9.22563V5.02563H8.51215C8.30704 5.02563 8.119 5.1111 7.94805 5.28203C7.77712 5.45299 7.69165 5.64102 7.69165 5.84613V26.1539C7.69165 26.359 7.77712 26.547 7.94805 26.718C8.119 26.8889 8.30704 26.9744 8.51215 26.9744H23.4865C23.6917 26.9744 23.8797 26.8889 24.0506 26.718C24.2216 26.547 24.307 26.359 24.307 26.1539V10.1487H20.0583C19.8092 10.1487 19.593 10.0572 19.4099 9.87403C19.2268 9.69092 19.1352 9.47479 19.1352 9.22563Z"
      fill="#4660F9"
    />
  </SVG>
);

export const CheckIcon = ({ width = '14', height = '14' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_12871_3537)">
      <path
        d="M5.24909 9.44993L2.79909 6.99993L1.98242 7.8166L5.24909 11.0833L12.2491 4.08327L11.4324 3.2666L5.24909 9.44993Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_12871_3537">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </SVG>
);

export const DeliveryDate = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.9204 18.5C14.2401 18.5 13.6667 18.2651 13.2 17.7954C12.7333 17.3257 12.5 16.7507 12.5 16.0704C12.5 15.3901 12.7349 14.8167 13.2046 14.35C13.6743 13.8833 14.2493 13.65 14.9296 13.65C15.6099 13.65 16.1833 13.8849 16.65 14.3546C17.1167 14.8243 17.35 15.3993 17.35 16.0796C17.35 16.7599 17.1151 17.3333 16.6454 17.8C16.1757 18.2667 15.6007 18.5 14.9204 18.5ZM4.5 22C4.1 22 3.75 21.85 3.45 21.55C3.15 21.25 3 20.9 3 20.5V5C3 4.6 3.15 4.25 3.45 3.95C3.75 3.65 4.1 3.5 4.5 3.5H6.125V2.8C6.125 2.57333 6.20167 2.38333 6.355 2.23C6.50833 2.07667 6.69833 2 6.925 2C7.15875 2 7.35469 2.07667 7.51283 2.23C7.67094 2.38333 7.75 2.57333 7.75 2.8V3.5H16.25V2.8C16.25 2.57333 16.3267 2.38333 16.48 2.23C16.6333 2.07667 16.8233 2 17.05 2C17.2838 2 17.4797 2.07667 17.6378 2.23C17.7959 2.38333 17.875 2.57333 17.875 2.8V3.5H19.5C19.9 3.5 20.25 3.65 20.55 3.95C20.85 4.25 21 4.6 21 5V20.5C21 20.9 20.85 21.25 20.55 21.55C20.25 21.85 19.9 22 19.5 22H4.5ZM4.5 20.5H19.5V9.75H4.5V20.5ZM4.5 8.25H19.5V5H4.5V8.25Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const StartDate = ({ height = '24', width = '24' }) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewbox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.82042 16.25C8.14014 16.25 7.56667 16.0151 7.1 15.5454C6.63333 15.0757 6.4 14.5007 6.4 13.8204C6.4 13.1401 6.63486 12.5667 7.10458 12.1C7.57429 11.6333 8.14929 11.4 8.82958 11.4C9.50986 11.4 10.0833 11.6349 10.55 12.1046C11.0167 12.5743 11.25 13.1493 11.25 13.8296C11.25 14.5099 11.0151 15.0833 10.5454 15.55C10.0757 16.0167 9.50071 16.25 8.82042 16.25ZM4.5 22C4.1 22 3.75 21.85 3.45 21.55C3.15 21.25 3 20.9 3 20.5V5C3 4.6 3.15 4.25 3.45 3.95C3.75 3.65 4.1 3.5 4.5 3.5H6.125V2.8C6.125 2.57333 6.20167 2.38333 6.355 2.23C6.50833 2.07667 6.69833 2 6.925 2C7.15875 2 7.35469 2.07667 7.51283 2.23C7.67094 2.38333 7.75 2.57333 7.75 2.8V3.5H16.25V2.8C16.25 2.57333 16.3267 2.38333 16.48 2.23C16.6333 2.07667 16.8233 2 17.05 2C17.2838 2 17.4797 2.07667 17.6378 2.23C17.7959 2.38333 17.875 2.57333 17.875 2.8V3.5H19.5C19.9 3.5 20.25 3.65 20.55 3.95C20.85 4.25 21 4.6 21 5V20.5C21 20.9 20.85 21.25 20.55 21.55C20.25 21.85 19.9 22 19.5 22H4.5ZM4.5 20.5H19.5V9.75H4.5V20.5ZM4.5 8.25H19.5V5H4.5V8.25Z"
      fill="#A3A5B7"
    />
  </SVG>
);

export const ServiceIcon = ({ height = '24', width = '24' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M12.5174 6.06654L9.93412 3.4832L11.1008 2.31654C11.2897 2.12765 11.523 2.0332 11.8008 2.0332C12.0786 2.0332 12.3119 2.12765 12.5008 2.31654L13.6841 3.49987C13.873 3.68876 13.9674 3.92209 13.9674 4.19987C13.9674 4.47765 13.873 4.71098 13.6841 4.89987L12.5174 6.06654ZM2.00078 13.9999V11.3999L5.23411 8.16654L1.55078 4.46654L4.45078 1.5332L8.16745 5.24987L9.93412 3.4832L12.5174 6.06654L10.7508 7.8332L14.4674 11.5499L11.5508 14.4332L7.85078 10.7499L4.60078 13.9999H2.00078ZM5.95078 7.44987L7.45078 5.94987L6.23411 4.7332L5.43411 5.5332L4.73411 4.8332L5.53411 4.0332L4.46745 2.96654L2.96745 4.46654L5.95078 7.44987ZM11.5174 13.0332L13.0174 11.5332L11.9508 10.4665L11.1508 11.2665L10.4508 10.5665L11.2508 9.76654L10.0341 8.54987L8.53411 10.0499L11.5174 13.0332ZM3.00078 12.9999H4.16745L11.0841 6.0832L9.91745 4.91654L3.00078 11.8332V12.9999Z"
        strokeLinecap="round"
        fill="#A3A5B7"
      />
    </svg>
  );
};

export const EditNameIcon = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M3 15.8001C2.73333 15.8001 2.5 15.7001 2.3 15.5001C2.1 15.3001 2 15.0667 2 14.8001V4.80006C2 4.5334 2.1 4.30007 2.3 4.10006C2.5 3.90007 2.73333 3.80006 3 3.80006H9.75L8.75 4.80006H3V14.8001H13V9.00006L14 8.00006V14.8001C14 15.0667 13.9 15.3001 13.7 15.5001C13.5 15.7001 13.2667 15.8001 13 15.8001H3ZM11.0333 3.9334L11.75 4.6334L7 9.36673V10.8001H8.41667L13.1833 6.0334L13.8833 6.7334L9.13333 11.5001C9.04444 11.589 8.93611 11.6612 8.80833 11.7167C8.68055 11.7723 8.55 11.8001 8.41667 11.8001H6.5C6.35556 11.8001 6.23611 11.7528 6.14167 11.6584C6.04722 11.564 6 11.4445 6 11.3001V9.3834C6 9.25006 6.02778 9.11951 6.08333 8.99173C6.13889 8.86395 6.21111 8.75562 6.3 8.66673L11.0333 3.9334ZM13.8833 6.7334L11.0333 3.9334L12.7 2.26673C12.8889 2.07784 13.125 1.9834 13.4083 1.9834C13.6917 1.9834 13.9278 2.0834 14.1167 2.2834L15.5167 3.70007C15.7056 3.90007 15.8 4.13618 15.8 4.4084C15.8 4.68062 15.7 4.91118 15.5 5.10006L13.8833 6.7334Z"
        fill="black"
      />
    </svg>
  );
};

export const ListingStatement = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M4.33333 6.28333H9.33333C9.475 6.28333 9.59375 6.23525 9.68958 6.13908C9.78542 6.04293 9.83333 5.92377 9.83333 5.78162V5.2799C9.83333 5.13774 9.78542 5.01944 9.68958 4.925C9.59375 4.83056 9.475 4.78333 9.33333 4.78333H4.33333C4.19167 4.78333 4.07292 4.83142 3.97708 4.92758C3.88125 5.02374 3.83333 5.14289 3.83333 5.28505V5.78677C3.83333 5.92892 3.88125 6.04722 3.97708 6.14167C4.07292 6.23611 4.19167 6.28333 4.33333 6.28333ZM3 14C2.73333 14 2.5 13.9 2.3 13.7C2.1 13.5 2 13.2667 2 13V3C2 2.73333 2.1 2.5 2.3 2.3C2.5 2.1 2.73333 2 3 2H13C13.2667 2 13.5 2.1 13.7 2.3C13.9 2.5 14 2.73333 14 3V13C14 13.2667 13.9 13.5 13.7 13.7C13.5 13.9 13.2667 14 13 14H3ZM3 13H13V3H3V13Z"
        fill="black"
      />
    </svg>
  );
};

export const ListingStatus = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M8 10.6997L6.7 12.0163C6.6 12.1163 6.48333 12.1663 6.35 12.1663C6.21667 12.1663 6.1 12.1163 6 12.0163C5.9 11.9163 5.85 11.7969 5.85 11.658C5.85 11.5191 5.9 11.3997 6 11.2997L7.3 9.99967L5.98333 8.69967C5.88333 8.59967 5.83333 8.48301 5.83333 8.34967C5.83333 8.21634 5.88333 8.09967 5.98333 7.99967C6.08333 7.89967 6.20278 7.84967 6.34167 7.84967C6.48056 7.84967 6.6 7.89967 6.7 7.99967L8 9.29967L9.3 7.98301C9.4 7.88301 9.51667 7.83301 9.65 7.83301C9.78333 7.83301 9.9 7.88301 10 7.98301C10.1 8.08301 10.15 8.20245 10.15 8.34134C10.15 8.48023 10.1 8.59967 10 8.69967L8.7 9.99967L10.0167 11.2997C10.1167 11.3997 10.1667 11.5163 10.1667 11.6497C10.1667 11.783 10.1167 11.8997 10.0167 11.9997C9.91667 12.0997 9.79722 12.1497 9.65833 12.1497C9.51944 12.1497 9.4 12.0997 9.3 11.9997L8 10.6997ZM3 14.6663C2.73333 14.6663 2.5 14.5663 2.3 14.3663C2.1 14.1663 2 13.933 2 13.6663V3.33301C2 3.06634 2.1 2.83301 2.3 2.63301C2.5 2.43301 2.73333 2.33301 3 2.33301H4.08333V1.86634C4.08333 1.71523 4.13444 1.58856 4.23667 1.48634C4.33889 1.38412 4.46556 1.33301 4.61667 1.33301C4.7725 1.33301 4.90313 1.38412 5.00855 1.48634C5.11396 1.58856 5.16667 1.71523 5.16667 1.86634V2.33301H10.8333V1.86634C10.8333 1.71523 10.8844 1.58856 10.9867 1.48634C11.0889 1.38412 11.2156 1.33301 11.3667 1.33301C11.5225 1.33301 11.6531 1.38412 11.7586 1.48634C11.864 1.58856 11.9167 1.71523 11.9167 1.86634V2.33301H13C13.2667 2.33301 13.5 2.43301 13.7 2.63301C13.9 2.83301 14 3.06634 14 3.33301V13.6663C14 13.933 13.9 14.1663 13.7 14.3663C13.5 14.5663 13.2667 14.6663 13 14.6663H3ZM3 13.6663H13V6.49967H3V13.6663ZM3 5.49967H13V3.33301H3V5.49967Z"
        strokeLinecap="round"
        fill="black"
      />
    </svg>
  );
};

export const ListingDelivery = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M6.5 1.66699C6.35833 1.66699 6.23958 1.6188 6.14375 1.52241C6.04792 1.42601 6 1.30656 6 1.16408C6 1.02158 6.04792 0.903103 6.14375 0.808659C6.23958 0.714214 6.35833 0.666992 6.5 0.666992H9.5C9.64167 0.666992 9.76042 0.715186 9.85625 0.811575C9.95208 0.907975 10 1.02742 10 1.16991C10 1.31241 9.95208 1.43088 9.85625 1.52533C9.76042 1.61977 9.64167 1.66699 9.5 1.66699H6.5ZM8.00292 9.11699C8.14542 9.11699 8.26389 9.06908 8.35833 8.97324C8.45278 8.87741 8.5 8.75866 8.5 8.61699V5.78366C8.5 5.64199 8.45181 5.52324 8.35542 5.42741C8.25902 5.33158 8.13957 5.28366 7.99708 5.28366C7.85458 5.28366 7.73611 5.33158 7.64167 5.42741C7.54722 5.52324 7.5 5.64199 7.5 5.78366V8.61699C7.5 8.75866 7.54819 8.87741 7.64458 8.97324C7.74098 9.06908 7.86043 9.11699 8.00292 9.11699ZM8 14.6503C7.17778 14.6503 6.40278 14.492 5.675 14.1753C4.94722 13.8587 4.31111 13.4281 3.76667 12.8837C3.22222 12.3392 2.79167 11.7031 2.475 10.9753C2.15833 10.2475 2 9.47255 2 8.65033C2 7.8281 2.15833 7.0531 2.475 6.32533C2.79167 5.59755 3.22222 4.96144 3.76667 4.41699C4.31111 3.87255 4.94722 3.44199 5.675 3.12533C6.40278 2.80866 7.17778 2.65033 8 2.65033C8.74444 2.65033 9.44444 2.77533 10.1 3.02533C10.7556 3.27533 11.3389 3.62255 11.85 4.06699L12.35 3.56699C12.45 3.46699 12.5667 3.41699 12.7 3.41699C12.8333 3.41699 12.95 3.46699 13.05 3.56699C13.15 3.66699 13.2 3.78366 13.2 3.91699C13.2 4.05033 13.15 4.16699 13.05 4.26699L12.55 4.76699C12.95 5.21144 13.2917 5.75033 13.575 6.38366C13.8583 7.01699 14 7.77255 14 8.65033C14 9.47255 13.8417 10.2475 13.525 10.9753C13.2083 11.7031 12.7778 12.3392 12.2333 12.8837C11.6889 13.4281 11.0528 13.8587 10.325 14.1753C9.59722 14.492 8.82222 14.6503 8 14.6503ZM8 13.6503C9.38889 13.6503 10.5694 13.1642 11.5417 12.192C12.5139 11.2198 13 10.0392 13 8.65033C13 7.26144 12.5139 6.08088 11.5417 5.10866C10.5694 4.13644 9.38889 3.65033 8 3.65033C6.61111 3.65033 5.43056 4.13644 4.45833 5.10866C3.48611 6.08088 3 7.26144 3 8.65033C3 10.0392 3.48611 11.2198 4.45833 12.192C5.43056 13.1642 6.61111 13.6503 8 13.6503Z"
        fill="black"
      />
    </svg>
  );
};

export const ListingServices = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M3 7.5C2.73333 7.5 2.5 7.4 2.3 7.2C2.1 7 2 6.76667 2 6.5V3C2 2.73333 2.1 2.5 2.3 2.3C2.5 2.1 2.73333 2 3 2H13C13.2667 2 13.5 2.1 13.7 2.3C13.9 2.5 14 2.73333 14 3V6.5C14 6.76667 13.9 7 13.7 7.2C13.5 7.4 13.2667 7.5 13 7.5H3ZM3 6.5H13V3H3V6.5ZM3 14C2.73333 14 2.5 13.9 2.3 13.7C2.1 13.5 2 13.2667 2 13V9.5C2 9.23333 2.1 9 2.3 8.8C2.5 8.6 2.73333 8.5 3 8.5H13C13.2667 8.5 13.5 8.6 13.7 8.8C13.9 9 14 9.23333 14 9.5V13C14 13.2667 13.9 13.5 13.7 13.7C13.5 13.9 13.2667 14 13 14H3ZM3 13H13V9.5H3V13Z"
        fill="black"
      />
    </svg>
  );
};

export const EditListingDate = ({ height = '16', width = '16' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      height={height}
      width={width}
      fill="none"
    >
      <path
        d="M5.88028 9.83398C5.42676 9.83398 5.04444 9.67741 4.73333 9.36427C4.42222 9.05112 4.26667 8.66779 4.26667 8.21427C4.26667 7.76074 4.42324 7.37843 4.73638 7.06732C5.04953 6.75621 5.43286 6.60065 5.88638 6.60065C6.33991 6.60065 6.72222 6.75722 7.03333 7.07037C7.34444 7.38351 7.5 7.76685 7.5 8.22037C7.5 8.67389 7.34343 9.05621 7.03028 9.36732C6.71714 9.67843 6.33381 9.83398 5.88028 9.83398ZM3 13.6673C2.73333 13.6673 2.5 13.5673 2.3 13.3673C2.1 13.1673 2 12.934 2 12.6673V2.33398C2 2.06732 2.1 1.83398 2.3 1.63398C2.5 1.43398 2.73333 1.33398 3 1.33398H4.08333V0.867318C4.08333 0.716207 4.13444 0.58954 4.23667 0.487318C4.33889 0.385096 4.46556 0.333984 4.61667 0.333984C4.7725 0.333984 4.90313 0.385096 5.00855 0.487318C5.11396 0.58954 5.16667 0.716207 5.16667 0.867318V1.33398H10.8333V0.867318C10.8333 0.716207 10.8844 0.58954 10.9867 0.487318C11.0889 0.385096 11.2156 0.333984 11.3667 0.333984C11.5225 0.333984 11.6531 0.385096 11.7586 0.487318C11.864 0.58954 11.9167 0.716207 11.9167 0.867318V1.33398H13C13.2667 1.33398 13.5 1.43398 13.7 1.63398C13.9 1.83398 14 2.06732 14 2.33398V12.6673C14 12.934 13.9 13.1673 13.7 13.3673C13.5 13.5673 13.2667 13.6673 13 13.6673H3ZM3 12.6673H13V5.50065H3V12.6673ZM3 4.50065H13V2.33398H3V4.50065Z"
        fill="#7D7D7D"
      />
    </svg>
  );
};
